/**
 * <s-mg-showcase> — Meta Glasses style switcher. Thumbnail buttons ([data-mg-thumb]) pick a style;
 * the matching slide image ([data-mg-slide]) and "Shop" pill ([data-mg-link]) get [data-active],
 * and the pressed thumbnail gets aria-current="true". Index comes from document order.
 */
class SMgShowcase extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.thumbs = [...this.querySelectorAll('[data-mg-thumb]')];
    this.thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => this.#select(index), { signal: this.#ac.signal });
    });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #select(index) {
    this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
    for (const selector of ['[data-mg-slide]', '[data-mg-link]']) {
      this.querySelectorAll(selector).forEach((element, i) => element.toggleAttribute('data-active', i === index));
    }
  }
}

if (!customElements.get('s-mg-showcase')) customElements.define('s-mg-showcase', SMgShowcase);
